"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLeaflet = require("react-leaflet");

require("leaflet/dist/leaflet.css");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

require("@identitybuilding/idb-react-ui-elements/dist/styles/Colors.css");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

require("./Style.css");

var _Sidebar = require("./components/Sidebar");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _leaflet = require("leaflet");

var _leaflet2 = _interopRequireDefault(_leaflet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyMap = function MyMap(props) {
  var _useState = (0, _react.useState)([{ name: 'regions', active: false, loaded: false }, { name: 'provinces', active: true, loaded: true }, { name: 'districts', active: false, loaded: false }, { name: 'municipalities', active: true, loaded: true }, { name: 'sub_municipalities', active: false, loaded: false }]),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      borders = _useState2[0],
      setBorders = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      country = _useState4[0],
      setCountry = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      current = _useState6[0],
      setCurrent = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      regions = _useState8[0],
      setRegions = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      provinces = _useState10[0],
      setProvinces = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      arrondissementen = _useState12[0],
      setArrondissementen = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
      municipalities = _useState14[0],
      setMunicipalities = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = (0, _slicedToArray3.default)(_useState15, 2),
      subMunicipalities = _useState16[0],
      setSubMunicipalities = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray3.default)(_useState17, 2),
      baseLayer = _useState18[0],
      _setBaseLayer = _useState18[1];

  var _useState19 = (0, _react.useState)(true),
      _useState20 = (0, _slicedToArray3.default)(_useState19, 2),
      baseNames = _useState20[0],
      _setBaseNames = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray3.default)(_useState21, 2),
      baseUrl = _useState22[0],
      setBaseUrl = _useState22[1];

  var _useState23 = (0, _react.useState)(true),
      _useState24 = (0, _slicedToArray3.default)(_useState23, 2),
      showSidebar = _useState24[0],
      setShowSidebar = _useState24[1];

  // Diffrent styles for each NIS layer(s)


  var countryStyle = {
    style: { fillColor: "var(--grey-100)", fillOpacity: 0.1, color: "var(--main)", weight: 3, className: 'country' }
  };
  var regionStyle = {
    style: { fillColor: "none", fillOpacity: 1, color: "var(--grey-80)", weight: 3, className: 'regions' }
  };
  var provinceStyle = {
    style: { fillColor: "none", fillOpacity: 0, color: "var(--sub)", weight: 2, className: 'provinces' }
  };
  var arrondissementenStyle = {
    style: { fillColor: "none", fillOpacity: 0, color: "var(--grey-80)", weight: 1.5, className: 'districts' }
  };
  var municialityStyle = {
    style: { fillColor: "var(--grey-50)", fillOpacity: 0.2, color: "var(--grey-50)", weight: 1, className: 'municipalities' },
    style_hover: { fillColor: "var(--grey-70)", fillOpacity: 0.5, color: "var(--grey-50)", weight: 1 },
    style_active: { fillColor: "var(--main)", fillOpacity: 0.75, color: "var(--grey-50)", weight: 2 },
    style_active_hover: { fillColor: "var(--main)", fillOpacity: 0.5, color: "var(--grey-50)", weight: 2 }
  };
  var submunicialityStyle = {
    style: { fillColor: "transparent", fillOpacity: 0, color: "var(--grey-50)", weight: 1, className: 'sub_municipalities' }
  };

  var mapRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    getInitialData();
    return function () {};
  }, []);

  // Let country and the municipalities load in first
  var getInitialData = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios2.default.get('https://o-sn.be/kml/belgium/country.min.json').then(function (res) {
                setCountry(res.data);
                var newParent = document.getElementById('custom-map-controls');
                var oldParent = document.getElementsByClassName("leaflet-bottom leaflet-left");
                while (oldParent[0].childNodes.length > 0) {
                  newParent.appendChild(oldParent[0].childNodes[0]);
                }
              });

            case 2:
              _context.next = 4;
              return _axios2.default.get('https://o-sn.be/kml/belgium/municipalities.min.json').then(function (res) {
                setMunicipalities(res.data);
              });

            case 4:
              _context.next = 6;
              return _axios2.default.get('https://o-sn.be/kml/belgium/provinces.min.json').then(function (res) {
                setProvinces(res.data);
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function getInitialData() {
      return _ref.apply(this, arguments);
    };
  }();

  // Get the remaining data only when selected on checkbox
  var getOtherData = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(name) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _axios2.default.get("https://o-sn.be/kml/belgium/" + (name === 'districts' ? 'arrondissementen' : name) + ".min.json").then(function (res) {
                if (name === 'regions') {
                  setRegions(res.data);
                } else if (name === 'provinces') {
                  setProvinces(res.data);
                } else if (name === 'districts') {
                  setArrondissementen(res.data);
                } else {
                  setSubMunicipalities(res.data);
                }
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function getOtherData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var mouseOverHandler = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(feature, layer) {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (feature.properties.active === 'true') {
                layer.setStyle(municialityStyle.style_active_hover);
              } else {
                layer.setStyle(municialityStyle.style_hover);
              }

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function mouseOverHandler(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var mouseOutHandler = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(feature, layer) {
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (feature.properties.active === 'true') {
                layer.setStyle(municialityStyle.style_active);
              } else {
                layer.setStyle(municialityStyle.style);
              }

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function mouseOutHandler(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var _checkboxHandler = function _checkboxHandler(border, index) {
    var copy = [].concat((0, _toConsumableArray3.default)(borders));
    // If it's not already active, load them in first
    if (!copy[index].loaded) {
      getOtherData(border.name);
      copy[index].loaded = true;
    }
    // otherwise, play with css to make them (in)visible
    else {

        var layers = document.getElementsByClassName(border.name);
        for (var i = 0; i < layers.length; i++) {
          if (copy[index].active) {
            layers[i].classList.add('hidden');
          } else {

            layers[i].classList.remove('hidden');
          }
        }
      }
    copy[index].active = !copy[index].active;
    setBorders(copy);
  };

  var onEachFeature = function onEachFeature(feature, layer) {
    var fprops = feature.properties;
    if (fprops.Language === 'NL / FR') {
      fprops.Language = props.lang.toUpperCase();
    }
    if (fprops.active === 'true') {
      layer.setStyle(municialityStyle.style_active);
    }
    // to display the mapinfo when hovering and not when out
    var mapInfo = document.getElementById('mapInfo');

    // get the proper base url based on the languages
    var BASEURL = '';
    // if (fprops.Language === 'DE' && props.lang === 'nl') { BASEURL = '100procentlokaal.be' }
    // else if (fprops.Language === 'DE' && props.lang === 'fr') { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'NL' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100procentlokaal.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'NL' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100procentlokaal.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'FR' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'FR' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100procentlokaal.be' }

    // else if (props.lang === 'fr' && fprops.Language === 'FR' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'fr' && fprops.Language === 'FR' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'fr' && fprops.Language === 'NL' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100procentlokaal.be' }
    // else if (props.lang === 'fr' && fprops.Language === 'NL' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    if (props.lang === 'nl') {
      BASEURL = '100procentlokaal.be';
    } else {
      BASEURL = '100pourcentlocale.be';
    }

    setBaseUrl(BASEURL);
    var municipalityName = fprops["Name" + props.lang.toUpperCase()].toLowerCase()
    // .replace('â', 'a')
    .replace(" (stad)", '').replace(" (ville)", '').replace(" (stadt)", '').replace(" city", '').replace(/\ /g, '').replace("'", '');
    if (municipalityName === 'sgravenbrakel') {
      municipalityName = 's-gravenbrakel';
    }
    if (municipalityName === 'mont-de-lenclus') {
      municipalityName = 'montdelenclus';
    }
    if (municipalityName === 'lesbonsvillers') {
      municipalityName = 'les-bons-villers';
    }

    layer.bindTooltip(municipalityName + "." + BASEURL, { direction: 'top' });
    layer.on({
      'click': function click() {
        window.open("https://" + municipalityName + "." + BASEURL);
      },

      'mouseover': function mouseover() {
        mouseOverHandler(feature, layer);
        setCurrent(fprops.PostalCode + '|' + fprops["Name" + props.lang.toUpperCase()]);
        mapInfo.style.display = 'flex';
        layer.openTooltip();
      },
      'mouseout': function mouseout() {
        mouseOutHandler(feature, layer);
        mapInfo.style.display = 'none';
      }
    });
  };

  return _react2.default.createElement(
    "div",
    { className: "percentlocal_wrapper", style: { display: 'flex', height: '100vh' } },
    showSidebar && _react2.default.createElement(_Sidebar2.default, {
      borders: borders,
      lang: props.lang,
      checkboxHandler: function checkboxHandler(border, index) {
        return _checkboxHandler(border, index);
      },
      setBaseLayer: function setBaseLayer(e) {
        return _setBaseLayer(e);
      },
      setBaseNames: function setBaseNames(e) {
        return _setBaseNames(e);
      },
      baseLayer: baseLayer,
      baseNames: baseNames,
      baseUrl: baseUrl
    }),
    _react2.default.createElement(
      "div",
      { id: "mapInfo" },
      _react2.default.createElement(_idbReactIconlib2.default, { name: "Mapmarker" }),
      _react2.default.createElement(
        "p",
        null,
        current
      )
    ),
    _react2.default.createElement(
      _reactLeaflet.Map,
      { style: { height: "100vh", width: '100%' }, zoom: 9, center: [50.75, 4.58], zoomControl: false, ref: mapRef },
      _react2.default.createElement(_reactLeaflet.ZoomControl, { position: "bottomright" }),
      _react2.default.createElement(_reactLeaflet.TileLayer, {
        attribution: "\xA9 <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
        url: baseLayer ? 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png' : ''
      }),
      _react2.default.createElement(_reactLeaflet.TileLayer, {
        attribution: "\xA9 <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
        url: baseNames ? 'https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png' : ''
      }),
      country &&
      // By using Panes, I can define the order with Zindex, because we can't give Z-index to svg elements
      _react2.default.createElement(
        _reactLeaflet.Pane,
        { style: { zIndex: 406 } },
        _react2.default.createElement(_reactLeaflet.GeoJSON, {
          style: countryStyle.style,
          data: country.features
        })
      ),
      regions && _react2.default.createElement(
        _reactLeaflet.Pane,
        { style: { zIndex: 405 } },
        _react2.default.createElement(_reactLeaflet.GeoJSON, {
          style: regionStyle.style,
          data: regions.features
        })
      ),
      provinces && _react2.default.createElement(
        _reactLeaflet.Pane,
        { style: { zIndex: 404 } },
        _react2.default.createElement(_reactLeaflet.GeoJSON, {
          style: provinceStyle.style,
          data: provinces.features
        })
      ),
      arrondissementen && _react2.default.createElement(
        _reactLeaflet.Pane,
        { style: { zIndex: 403 } },
        _react2.default.createElement(_reactLeaflet.GeoJSON, {
          style: arrondissementenStyle.style,
          data: arrondissementen.features
        })
      ),
      municipalities && _react2.default.createElement(
        _reactLeaflet.Pane,
        { style: { zIndex: 402 } },
        _react2.default.createElement(_reactLeaflet.GeoJSON, {
          style: municialityStyle.style,
          data: municipalities.features,
          onEachFeature: onEachFeature
        })
      ),
      subMunicipalities && _react2.default.createElement(
        _reactLeaflet.Pane,
        { style: { zIndex: 401 } },
        _react2.default.createElement(_reactLeaflet.GeoJSON, {
          style: submunicialityStyle.style,
          data: subMunicipalities.features
        })
      )
    )
  );
};

exports.default = MyMap;